import { render } from "./customInstrument.vue?vue&type=template&id=4d13404d&scoped=true"
import script from "./customInstrument.vue?vue&type=script&lang=js"
export * from "./customInstrument.vue?vue&type=script&lang=js"

import "./customInstrument.vue?vue&type=style&index=0&id=4d13404d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d13404d"]])

export default __exports__